import React from 'react';
import { BookingPage } from '@/components/booking-page';

export default function BookingPageRoute() {
  return <BookingPage />;
}
